import { render } from "./GeoSelectorWithoutDivisionUnion.vue?vue&type=template&id=963ce958"
import script from "./GeoSelectorWithoutDivisionUnion.vue?vue&type=script&lang=js"
export * from "./GeoSelectorWithoutDivisionUnion.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/provider-frontend/provider-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__